<template>
  <div class="standart-page">
    <b-modal
      id="modal-cancel-confirm"
      centered
      title="Uyarı"
      header-bg-variant="warning"
      header-text-variant="light"
      ok-variant="success"
      ok-title="Tamam"
      cancel-variant="outline-secondary"
      cancel-title="Vazgeç"
      @ok.prevent="$router.go(-1)"
    >
    </b-modal>
    <div class="row mb-3">
      <div class="col-3"></div>
      <div class="col d-flex align-items-center justify-content-center">
        <h3 class="title mb-0">{{ $store.state.ie.detail.pageTitle }}</h3>
      </div>
      <div class="col-3 d-flex justify-content-end align-items-center">
        <button class="btn btn-outline-secondary back-button" @click="goBack">
          <font-awesome-icon icon="angle-double-left" class="mr-2"/>
          Listeye Geri Dön
        </button>
      </div>
    </div>
    <div class="row justify-content-center mb-4" v-if="$store.state.ie.recordId != 0">
      <div class="col-5 d-flex justify-content-center">
        <button
          class="btn btn-block mr-2 mt-0 wsnw"
          :class="activeTab === 0 ? 'btn-secondary' : 'btn-outline-secondary'"
          @click="changeComponent(0, 'IEPublicInfos')"
        >
          Genel Bilgiler
        </button>
        <Can I="read" a="/ilim-edebiyat-eseri/IlimEdebiyatEseriNot">
          <button
            class="btn btn-block mr-2 mt-0 wsnw"
            :class="activeTab === 1 ? 'btn-secondary' : 'btn-outline-secondary'"
            @click="changeComponent(1, 'IENot')"
          >
            Notlar
          </button>
        </Can>
        <Can I="read" a="/ilim-edebiyat-eseri/IlimEdebiyatEseriDokuman">
          <button
            class="btn btn-block mr-2 mt-0 wsnw"
            :class="activeTab === 2 ? 'btn-secondary' : 'btn-outline-secondary'"
            @click="changeComponent(2, 'IEDokuman')">
            Dokümanlar
          </button>
        </Can>
        <Can I="read" a="/ilim-edebiyat-eseri/IlimEdebiyatEseriLog2">
          <button
            class="btn btn-block mr-2 mt-0 wsnw"
            :class="activeTab === 3 ? 'btn-secondary' : 'btn-outline-secondary'"
            @click="changeComponent(3, 'IELog')"
          >
            Loglar
          </button>
        </Can>
      </div>
    </div>
    <component :is="$store.state.ie.detail.currentTab" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},
  data() {
    return {
      activeTab: 0,
    };
  },
  methods: {
    ...mapActions("ie", ["changeDetailTab"]),
    changeComponent(id, cmp) {
      this.activeTab = id;
      this.changeDetailTab(cmp);
    },
    goBack() {
      if (this.isChanged) {
        this.$bvModal.show("modal-cancel-confirm");
      } else {
        this.$router.go(-1);
      }
    },
  },
  created() {
    this.changeComponent(0, "IEPublicInfos");
    this.$store.state.ie.recordId = 0;
  },
  computed: {
    ...mapGetters("general", ["getMessage"]),
  },
  watch: {},
};
</script>